<template>
  <!-- Add Leave Modal -->
  <div id="add_leave" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add leave</h5>
          <button ref="Close" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetData">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="addLeave">
            <div class="input-block mb-3">
              <label class="col-form-label">Employee name<span class="text-danger">*</span></label>
              <vue-select v-model="selectedEmployee" :options="employeeIds"
                :settings="{ dropdownParent: '#add_leave' }"
                @select="mySelectEvent($event, 'selectedEmployee')" placeholder="Select Employee Name" />
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label">Leave category <span class="text-danger">*</span></label>
              <vue-select v-model="selectedCategory" :options="masterCategoryIds"
                @select="mySelectEvent($event, 'selectedCategory')" placeholder="Select Leave Category" />
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label">Leave status <span class="text-danger">*</span></label>
              <vue-select v-model="selectedStatus" :options="SelectStatus"
                @select="mySelectEvent($event, 'selectedStatus')" placeholder="Select Leave Status" />
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label">Type<span class="text-danger">*</span></label>
              <vue-select v-model="selectedLeaveType" :options="leaveTypes" placeholder="Leave Type" />
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label">Paid/Unpaid<span class="text-danger">*</span></label>
              <vue-select v-model="isPaid" :options="paidOptions" placeholder="Paid/Unpaid"
                @select="mySelectEvent($event, 'isPaid')" />
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label">Leave Hours (per day)<span class="text-danger">*</span></label>
              <input class="form-control" v-model="leaveHours" type="text" placeholder="e.g. 07:30" />
            </div>
            <!-- <div class="input-block mb-3">
              <label class="col-form-label"
              >Leave Type <span class="text-danger">*</span></label
              >
              <input class="form-control" v-model="leaveType" type="text" />
            </div> -->
            <div v-if="selectedLeaveType == 'Multiple'">
              <div class="input-block mb-3">
                <label class="col-form-label">From <span class="text-danger">*</span></label>
                <div class="cal-icon">
                  <date-picker v-model="startDate" class="form-control datetimepicker" :clearable="false"
                    :inputFormat="dateFormat" />
                </div>
              </div>
              <div class="input-block mb-3">
                <label class="col-form-label">To <span class="text-danger">*</span></label>
                <div class="cal-icon">
                  <date-picker v-model="endDate" class="form-control datetimepicker" :editable="true" :clearable="false"
                    :inputFormat="dateFormat" />
                </div>
              </div>
            </div>


            <div v-else class="input-block mb-3">
              <label class="col-form-label">Date<span class="text-danger">*</span></label>
              <div class="cal-icon">
                <date-picker v-model="date" class="form-control datetimepicker" :editable="true" :clearable="false"
                  :inputFormat="dateFormat" />
              </div>
            </div>

            <div v-if="selectedLeaveType == 'Half'">
              <div class="row">
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">Start time <span class="text-danger">*</span></label>
                    <div class="input-group time">
                      <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, $data, 'fromTime')" v-model="fromTime" class="form-control timepicker" placeholder="00:00:00" />
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">End time <span class="text-danger">*</span></label>
                    <div class="input-group time">
                      <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, $data, 'toTime')" v-model="toTime" class="form-control timepicker" placeholder="00:00:00" />
                    </div>
                  </div>
                </div>
              </div>


              <!-- <div class="input-block mb-3">
                  <label class="col-form-label">Start Time</label>
                  <vue-select
                    :options="Scheduletime"
                    id="scheduletime"
                    placeholder="12:00 AM-01:00 AM"
                  />
                </div>
                <div class="input-block mb-3">
                  <label class="col-form-label">End Time</label>
                  <vue-select
                    :options="Scheduletime"
                    id="scheduletime"
                    placeholder="12:00 AM-01:00 AM"
                  />
                </div> -->
              <div class="input-block mb-3">
                <label class="col-form-label">Half no<span class="text-danger">*</span></label>
                <vue-select v-model="selectedHalfType" :options="halfType" placeholder="Half No"
                  @select="mySelectEvent($event, 'selectedHalfType')" />
              </div>
            </div>

            <!-- <div class="input-block mb-3">
              <label class="col-form-label"
                >Number of days <span class="text-danger">*</span></label
              >
              <input class="form-control" v-model="noOfDays" type="text" />
            </div> -->
            <!--            <div class="input-block mb-3">-->
            <!--              <label class="col-form-label"-->
            <!--                >Remaining Leaves <span class="text-danger">*</span></label-->
            <!--              >-->
            <!--              <input class="form-control" readonly value="12" type="text" />-->
            <!--            </div>-->
            <div class="input-block mb-3" v-if="showSicknessDetails">
              <label class="col-form-label">Details of sickness/injury<span class="text-danger">*</span></label>
              <textarea rows="2" v-model="sicknessDetails" class="form-control"></textarea>
            </div>
            <div class="input-block mb-3" v-else-if="!selectedCategoryName.includes('annual')">
              <label class="col-form-label">Leave reason<span class="text-danger">*</span></label>
              <textarea rows="2" v-model="leaveReason" class="form-control"></textarea>
            </div>

            <div class="input-block mb-3" v-if="showSicknessDetails">
              <label class="col-form-label">
                Did user consult a doctor?
              </label>
              <!-- <div class="mt-3 d-flex flex-wrap gap-3"> -->
              <div class="mt-3">
                <div class="form-check form-check-inline" v-for="option in userOptions" :key="option.value">
                  <input class="form-check-input" type="radio" :id="option.value" name="userType" :value="option.value"
                    v-model="consultDoctor" />
                  <label class="form-check-label" :for="option.value">{{ option.label }}</label>
                </div>
              </div>
            </div>
            <div class="input-block mb-3" v-if="consultDoctor == false && showSicknessDetails">
              <label class="col-form-label">Reason for not consulting the doctor<span
                  class="text-danger">*</span></label>
              <textarea rows="2" v-model="leaveReason" class="form-control"></textarea>
            </div>
            <div class="input-block mb-3" v-if="consultDoctor == true && showSicknessDetails">
              <label class="col-form-label">Doctor name<span class="text-danger">*</span></label>
              <input class="form-control" v-model="doctorName" type="text" />
            </div>
            <div class="input-block mb-3" v-if="consultDoctor == true && showSicknessDetails">

              <label class="col-form-label">Doctor visit date<span class="text-danger">*</span></label>
              <div class="cal-icon">
                <date-picker v-model="doctorVisitDate" class="form-control datetimepicker" :editable="true"
                  :clearable="false" :inputFormat="dateFormat" />

              </div>
              <div class="input-block mb-3" v-if="consultDoctor == true && showSicknessDetails">
                <label class="col-form-label">Treatment received<span class="text-danger">*</span></label>
                <textarea rows="2" v-model="treatmentReceived" class="form-control"></textarea>
              </div>
            </div>
            <div>

            </div>

            <div class="submit-section">
              <button type="button" class="btn btn-info submit-btn me-2" @click="checkSchedule">Check Schedule</button>
              <button type="submit" class="btn btn-primary submit-btn"><span v-if="!loading">Submit</span>
                <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Leave Modal -->

  <!-- Edit Leave Modal -->
  <div id="edit_leave" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Leave</h5>
          <button ref="EditClose" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submit">
            <div class="input-block mb-3">
              <label class="col-form-label">Leave category <span class="text-danger">*</span></label>
              <vue-select v-model="editCategory" :options="masterCategoryIds"
                @select="mySelectEvent($event, 'editCategory')" placeholder="Select Leave Category" />
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label">Leave Type<span class="text-danger">*</span></label>
              <vue-select v-model="editLeaveType" :options="leaveTypes" placeholder="Leave Type" />
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label">Leave Status <span class="text-danger">*</span></label>
              <vue-select v-model="leaveStatus" :options="SelectStatus" id="status" placeholder="Select Status" />
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label">Paid/Unpaid<span class="text-danger">*</span></label>
              <vue-select v-model="isPaid" :options="paidOptions" placeholder="Paid/Unpaid"
                @select="mySelectEvent($event, 'isPaid')" />
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label">Leave Hours (per day)<span class="text-danger">*</span></label>
              <input class="form-control" v-model="leaveHours" type="text" placeholder="e.g. 07:30" />
            </div>

            <div v-if="editLeaveType == 'Multiple'">
              <div class="input-block mb-3">
                <label class="col-form-label">From <span class="text-danger">*</span></label>
                <div class="cal-icon">
                  <date-picker v-model="startDate" class="form-control datetimepicker" :clearable="false"
                    :inputFormat="dateFormat" />
                </div>
              </div>
              <div class="input-block mb-3">
                <label class="col-form-label">To <span class="text-danger">*</span></label>
                <div class="cal-icon">
                  <date-picker v-model="endDate" class="form-control datetimepicker" :editable="true" :clearable="false"
                    :inputFormat="dateFormat" />
                </div>
              </div>
            </div>

            <div v-else class="input-block mb-3">
              <label class="col-form-label">Date<span class="text-danger">*</span></label>
              <div class="cal-icon">
                <date-picker v-model="date" class="form-control datetimepicker" :editable="true" :clearable="false"
                  :inputFormat="dateFormat" />
              </div>
            </div>

            <div v-if="editLeaveType == 'Half'">
              <div class="row">
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">Start time <span class="text-danger">*</span></label>
                    <div class="input-group time">
                      <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, $data, 'fromTime')" v-model="fromTime" class="form-control timepicker" placeholder="00:00:00" />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">End time <span class="text-danger">*</span></label>
                    <div class="input-group time">
                      <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, $data, 'toTime')" v-model="toTime" class="form-control timepicker" placeholder="00:00:00" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-block mb-3">
                <label class="col-form-label">Half no<span class="text-danger">*</span></label>
                <vue-select v-model="selectedHalfType" :options="halfType" placeholder="Half No"
                  @select="mySelectEvent($event, 'selectedHalfType')" />
              </div>
            </div>

            <div class="input-block mb-3" v-if="!editCategoryName.includes('annual')">
              <label class="col-form-label">{{ editShowSicknessDetails ? 'Details of sickness/injury' : 'Leave Reason' }} <span class="text-danger">*</span></label>
              <textarea rows="4" v-model="leaveReason" class="form-control"></textarea>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="submit">
                <span v-if="!loading">Save</span>
                <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Leave Modal -->

  <!-- Approve Leave Modal -->
  <div class="modal custom-modal fade" id="approve_leave" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Leave Approve</h3>
            <p>Are you sure want to approve for this leave?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn">Approve</a>
              </div>
              <div class="col-6">
                <a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-primary cancel-btn">Decline</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Approve Leave Modal -->

  <!-- Delete Leave Modal -->
  <div class="modal custom-modal fade" id="delete_approve" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Leave</h3>
            <p>Are you sure want to delete this leave?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="deleteClicked"
                  data-bs-dismiss="modal">Delete</a>
              </div>
              <div class="col-6">
                <a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-primary cancel-btn">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Leave Modal -->

  <!-- Check Schedule Modal -->
  <div id="check_schedule" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-body p-4">
          <div v-if="scheduleLoading" class="d-flex justify-content-center py-5">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else-if="scheduleData">
            <h4 class="mb-4" style="font-weight: 600;">Schedule</h4>

            <!-- Summary Cards Row 1 -->
            <div class="row g-3 mb-3">
              <div class="col-4">
                <div class="schedule-card">
                  <span class="schedule-card-label">Working days</span>
                  <span class="schedule-card-value">{{ scheduleSummary.working_days ?? 0 }}</span>
                </div>
              </div>
              <div class="col-4">
                <div class="schedule-card">
                  <span class="schedule-card-label">Non working days</span>
                  <span class="schedule-card-value">{{ scheduleSummary.non_working_days ?? 0 }}</span>
                </div>
              </div>
              <div class="col-4">
                <div class="schedule-card">
                  <span class="schedule-card-label">No schedule</span>
                  <span class="schedule-card-value">{{ scheduleSummary.no_schedule ?? 0 }}</span>
                </div>
              </div>
            </div>

            <!-- Summary Cards Row 2 -->
            <div class="row g-3 mb-4">
              <div class="col-4">
                <div class="schedule-card">
                  <span class="schedule-card-label">Work time</span>
                  <span class="schedule-card-value-lg">{{ minToTimeString(scheduleSummary.work_time) ?? '00:00' }}</span>
                </div>
              </div>
              <div class="col-4">
                <div class="schedule-card">
                  <span class="schedule-card-label">Break</span>
                  <span class="schedule-card-value-lg">{{ minToTimeString(scheduleSummary.break_paid) ?? '00:00' }}</span>
                </div>
              </div>
              <!-- <div class="col-4">
                <div class="schedule-card">
                  <span class="schedule-card-label">Break(unpaid)</span>
                  <span class="schedule-card-value-lg">{{ minToTimeString(scheduleSummary.break_unpaid) ?? '00:00' }}</span>
                </div>
              </div> -->
            </div>

            <!-- Schedule Table -->
            <div v-if="scheduleData.user_schedule && scheduleData.user_schedule.length">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th style="color: #888; font-weight: 500; border-top: none;">Date</th>
                    <th style="color: #888; font-weight: 500; border-top: none;">Schedule</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in scheduleData.user_schedule" :key="index">
                    <td>{{ formatDDMMYYYY(item.date) }}</td>
                    <td>{{ (item["user_schedule_shifts"] && item["user_schedule_shifts"].length > 0) ? timeFormat(item["user_schedule_shifts"][0].from_time) + ' - ' + timeFormat(item["user_schedule_shifts"][0].to_time) : '--' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Close Button -->
            <div class="text-end mt-3">
              <button type="button" class="btn btn-link text-danger text-decoration-none fw-semibold"
                data-bs-dismiss="modal">CLOSE</button>
            </div>
          </div>
          <div v-else class="text-center py-4">
            <p class="text-muted">No schedule found for the selected date range.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Check Schedule Modal -->
</template>

<script>
import { timeInputMixin } from "../../mixins/timeInputMixin";
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../config";
import { Modal } from "bootstrap";
import { minToTimeString, timeFormat, formatDDMMYYYY } from "../../utils/util-funcitons";
import dayjs from "dayjs";
export default {
  mixins: [timeInputMixin],
  emits: ["allLeaves", "userLeaves"],
  data() {
    return {
      select2: null,
      // loader:false,
      leaveType: '',
      leaveStatus: '',
      noOfDays: null,
      SelectStatus: ["APPROVED", "PENDING", "REJECTED", "HOLD"],
      selectedStatus: 'PENDING',
      startDate: null,
      dateFormat: 'dd/MM/yyyy',
      endDate: null,
      date: null,
      leaveReason: '',
      leaveId: null,
      masterCategoryIds: null,
      selectedCategory: null,
      editCategory: null,
      editLeaveType: null,
      employeeIds: null,
      selectedEmployee: null,
      selectedLeaveType: null,
      leaveTypes: ['Single', 'Half', 'Multiple'],
      selectedHalfType: null,
      halfType: ['First', 'Second'],
      fromTime: '',
      toTime: '',
      isPaid: 'Unpaid',
      paidOptions: ['Paid', 'Unpaid'],
      leaveHours: '00:00',

      userOptions: [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 }
      ],
      consultDoctor: false,
      doctorName: '',
      doctorVisitDate: null,
      treatmentReceived: '',
      sicknessDetails: '',
      loading: false,
      scheduleData: null,
      scheduleLoading: false,
      scheduleSummary: null,
    };
  },
  mounted() {
    this.getMasterCategories()
    this.getEmployeeList()
    
    // Reshow add_leave modal when check_schedule is closed
    const checkScheduleEl = document.getElementById('check_schedule');
    if (checkScheduleEl) {
      checkScheduleEl.addEventListener('hidden.bs.modal', () => {
        const addLeaveModal = Modal.getOrCreateInstance(document.getElementById('add_leave'));
        addLeaveModal.show();
      });
    }
  },
  methods: {
    formatDDMMYYYY,
    timeFormat,
    minToTimeString,
    updateStatus(record) {
      this.leaveType = record.type;
      this.leaveStatus = record.status;
      this.isPaid = record.is_paid == 1 ? 'Paid' : 'Unpaid';
      this.noOfDays = Number(record.no_of_days.includes(" days") ? record.no_of_days.replace(" days", '') : record.no_of_days.replace(" day", ''));
      // Use raw dates (ISO format) for date pickers, fallback to formatted dates if raw not available
      const rawStart = new Date(record.start_date_raw || record.start_date);
      const rawEnd = new Date(record.end_date_raw || record.end_date);
      this.leaveReason = record.reason;
      this.leaveId = record.id;
      this.editCategory = record.leave_master_category_id;
      this.editLeaveType = record.type;
      this.selectedHalfType = record.half_no || null;
      this.leaveHours = record.leave_hour || '00:00';

      // Set date fields based on type
      if (record.type === 'Multiple') {
        this.startDate = rawStart;
        this.endDate = rawEnd;
        this.date = null;
      } else {
        this.date = rawStart;
        this.startDate = null;
        this.endDate = null;
      }

      // Set time fields for half-day leaves
      if (record.type === 'Half') {
        const startParts = (record.start_date_raw || record.start_date).split(' ');
        const endParts = (record.end_date_raw || record.end_date).split(' ');
        this.fromTime = startParts.length > 1 ? startParts[1] : '';
        this.toTime = endParts.length > 1 ? endParts[1] : '';
      } else {
        this.fromTime = '';
        this.toTime = '';
      }
    },
    async submit() {
      this.loading = true;
      const data = {
        status: this.leaveStatus,
        is_paid: this.isPaid === 'Paid' ? 1 : 0,
        leave_master_category_id: this.editCategory,
        type: this.editLeaveType,
        reason: this.leaveReason,
        leave_hour: this.leaveHours,
      };

      // Set dates based on type
      switch (this.editLeaveType) {
        case 'Multiple': {
          data.start_date = dayjs(this.startDate).format('YYYY-MM-DD');
          data.end_date = dayjs(this.endDate).format('YYYY-MM-DD');
          break;
        }
        case 'Half': {
          data.start_date = dayjs(this.date).format('YYYY-MM-DD');
          data.start_time = this.fromTime;
          data.end_time = this.toTime;
          data.half_no = this.selectedHalfType;
          break;
        }
        case 'Single': {
          data.start_date = dayjs(this.date).format('YYYY-MM-DD');
          break;
        }
        default:
          break;
      }

      await axios.post(`${VUE_APP_API_BASE_URL}/leave/${this.leaveId}/update`, data)
        .then((response) => {
          if (response.data.status) {
            this.$emit("userLeaves");
            this.$emit("allLeaves");
            this.$toast.success(response.data.message);
            this.$refs.EditClose.click();
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        }).catch(function (error) {
          console.log('error ', error);
        }).finally(() => {
          this.loading = false;
        });
    },
    deleteLeave(id) {
      this.leaveId = id;
    },
    async deleteClicked() {
      await axios.post(`${VUE_APP_API_BASE_URL}/leave/${this.leaveId}/cancel`).then((response) => {
        if (response.data.status) {
          this.$emit("userLeaves");
          this.$emit("allLeaves");
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    async getMasterCategories() {
      await axios.get(`${VUE_APP_API_BASE_URL}/master-category`)
        .then((response) => {
          if (response.data.status) {
            this.masterCategoryIds = response.data.data;
            this.masterCategoryIds.forEach(element => {

              element['text'] = element['name'];
              delete element['name'];
            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    setEmployee(userId) {
      if (userId) {
        const targetId = typeof userId === 'object' ? (userId.id || userId.user_id) : userId;
        if (this.employeeIds && this.employeeIds.length) {
          const match = this.employeeIds.find(e => e.id == targetId);
          this.selectedEmployee = match ? match.id : (Number(targetId) || targetId);
        } else {
          this.selectedEmployee = Number(targetId) || targetId;
        }
      } else {
        this.selectedEmployee = null;
      }
    },
    updateValues(data) {
      if (data) {
        if (data.type || data.reason || data.leave_master_category_id) {
          this.updateStatus(data);
        } else {
          this.setEmployee(data);
        }
      }
    },

    async getEmployeeList() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.employeeIds = response.data.data;
            this.employeeIds.forEach(element => {

              element['text'] = element['first_name'] + ' ' + element['last_name'];
              delete element['first_name'];
              delete element['last_name'];
            });
            if (this.selectedEmployee) {
              const match = this.employeeIds.find(e => e.id == this.selectedEmployee);
              if (match) {
                this.selectedEmployee = match.id;
              }
            }
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    async checkSchedule() {
      if (!this.selectedEmployee) {
        this.$toast.error('Please select an employee first');
        return;
      }
      let startDateStr, endDateStr;
      if (this.selectedLeaveType === 'Multiple') {
        if (!this.startDate || !this.endDate) {
          this.$toast.error('Please select start and end dates');
          return;
        }
        startDateStr = dayjs(this.startDate).format('YYYY-MM-DD');
        endDateStr = dayjs(this.endDate).format('YYYY-MM-DD');
      } else {
        if (!this.date) {
          this.$toast.error('Please select a date');
          return;
        }
        startDateStr = dayjs(this.date).format('YYYY-MM-DD');
        endDateStr = startDateStr;
      }

      // Show modal programmatically only if validation passes
      const checkScheduleModal = Modal.getOrCreateInstance(document.getElementById('check_schedule'));
      checkScheduleModal.show();
      const addLeaveModal = Modal.getOrCreateInstance(document.getElementById('add_leave'));
      addLeaveModal.hide();

      this.scheduleLoading = true;
      this.scheduleData = null;
      try {
        const response = await axios.get(`${VUE_APP_API_BASE_URL}/user-schedule/range`, {
          params: {
            user_id: this.selectedEmployee,
            start_date: startDateStr,
            end_date: endDateStr
          }
        });
        if (response.data.status) {
          this.scheduleData = response.data.data;
          this.scheduleSummary = response.data.summary;
        } else {
          this.$toast.error(response.data.message || 'Failed to fetch schedule');
        }
      } catch (error) {
        console.log(error);
        this.$toast.error('Failed to fetch schedule');
      } finally {
        this.scheduleLoading = false;
      }
    },
    async addLeave() {
      // this.loader = true;
      this.loading = true;
      const data = {
        leave_master_category_id: this.selectedCategory,
        user_id: this.selectedEmployee,
        type: this.selectedLeaveType,
        reason: this.leaveReason,
        status: this.selectedStatus,
        is_paid: this.isPaid === 'Paid' ? 1 : 0,
        leave_hour: this.leaveHours,
        ...(this.showSicknessDetails && {
          ...(this.consultDoctor !== null && { is_doctor_visit: this.consultDoctor }),
          ...(this.doctorName && { doctor_name: this.doctorName }),
          ...(this.doctorVisitDate && { doctor_visit_date: dayjs(this.doctorVisitDate).format('YYYY-MM-DD') }),
          ...(this.sicknessDetails && { detail_sickness: this.sicknessDetails }),
          ...(this.treatmentReceived && { treatment: this.treatmentReceived }),
        })
      }
      // add start_date and end_date conditionally
      switch (this.selectedLeaveType) {
        case 'Multiple': {
          let startDateString = dayjs(this.startDate).format('YYYY-MM-DD');
          let endDateString = dayjs(this.endDate).format('YYYY-MM-DD');
          data.start_date = startDateString;
          data.end_date = endDateString;
          break;
        }
        case 'Half': {
          let dateStringHalf = dayjs(this.date).format('YYYY-MM-DD');
          data.start_date = dateStringHalf;
          data.start_time = this.fromTime;
          data.end_time = this.toTime;
          data.half_no = this.selectedHalfType;
          break;
        }
        case 'Single': {
          let dateStringSingle = dayjs(this.date).format('YYYY-MM-DD');
          data.start_date = dateStringSingle;
          break;
        }
        default:
          break;
      }

      await axios.post(`${VUE_APP_API_BASE_URL}/leave/add`, data)
        .then((response) => {
          if (response.data.status === true) {
            this.$toast.success(response.data.message);
            // this.$emit("leave application sent");
            this.$refs.Close.click();
            this.$router.go(0)
            // this.loader = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            // this.loader = false;
            // this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
          // this.loader = false;
        }).finally(() => {
          this.loading = false;
        });
    },

    mySelectEvent(event, input) {
      switch (input) {
        case 'selectedCategory':
          this.selectedCategory = event.id;
          break;
        case 'editCategory':
          this.editCategory = event.id;
          break;
        case 'selectedEmployee':
          this.selectedEmployee = event.id;
          break;
        case 'selectedType':
          this.selectedLeaveType = event.text;
          break;
        case 'selectedHalfType':
          this.selectedHalfType = event.text;
          break;
        case 'selectedStatus':
          this.selectedStatus = event.text;
          break;
        case 'isPaid':
          this.isPaid = event.text;
          break;
        default:
          break;
      }
    },
    resetData() {
      this.selectedEmployee = null;
      this.selectedCategory = null;
      this.selectedStatus = 'PENDING';
      this.selectedLeaveType = null;
      this.isPaid = 'Unpaid';
      this.leaveHours = '00:00';
      this.startDate = null;
      this.endDate = null;
      this.date = null;
      this.fromTime = null;
      this.toTime = null;
      this.selectedHalfType = null;
      this.leaveReason = '';
      this.sicknessDetails = '';
      this.consultDoctor = false;
      this.doctorName = '';
      this.doctorVisitDate = null;
      this.treatmentReceived = '';
    },
  },
  computed: {
    selectedCategoryName() {
      if (!this.masterCategoryIds || !this.selectedCategory) return '';
      const cat = this.masterCategoryIds.find(c => c.id === this.selectedCategory);
      return cat ? (cat.text || '').toLowerCase() : '';
    },
    editCategoryName() {
      if (!this.masterCategoryIds || !this.editCategory) return '';
      const cat = this.masterCategoryIds.find(c => c.id === this.editCategory);
      return cat ? (cat.text || '').toLowerCase() : '';
    },
    showSicknessDetails() {
      const name = this.selectedCategoryName;
      return name.includes('sick') || name.includes('ssp') || name.includes('smp') || name.includes('spp');
    },
    editShowSicknessDetails() {
      const name = this.editCategoryName;
      return name.includes('sick') || name.includes('ssp') || name.includes('smp') || name.includes('spp');
    }
  },

};
</script>

<style scoped>
.schedule-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
}
.schedule-card-label {
  font-size: 14px;
  color: #555;
  margin-bottom: 4px;
}
.schedule-card-value {
  font-size: 28px;
  font-weight: 700;
  color: #222;
}
.schedule-card-value-lg {
  font-size: 36px;
  font-weight: 700;
  color: #222;
}
</style>
